import React, { Component } from "react";
import { useLottie } from "lottie-react";
import vestbuildAnimation from "./vestabuild.json";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteLoaded 	= () => context.siteLoaded;
	const siteLoaded 		= ctxSiteLoaded();
	
	let coverClass = 'c-cover';
	
	if (siteLoaded === true) {
		coverClass = 'c-cover state-loaded';
	}
	
	const options = {
    	animationData: vestbuildAnimation,
    	loop: false,
    	autoplay: true
  	};

  	const { View } = useLottie(options)
  
	return (
		
		<div className={coverClass}>
			<div className="c-cover__logo">
				{ View }
			</div>
		</div>
	)
	
}
export default WithConsumer(Cover);